<template>
  <div class="cont-main">
    <div class="cont-title">基本信息</div>
    <div class="cont-form">
      <e-form
        ref="refForm1"
        class="flex-1"
        :config="formConfig"
        :column="formColumn1"
        :data.sync="detailData.report_bill"
      />
      <e-form
        ref="refForm2"
        class="flex-1"
        :config="formConfig"
        :column="formColumn2"
        :data.sync="detailData.report_bill"
      />
    </div>

    <div class="cont-title">销售清单</div>
    <div class="box-y-scroll p-r-5" :style="{ 'max-height': maxHeight }">
      <!-- 表格 -->
      <vxe-grid
        ref="refTable"
        size="mini"
        show-footer
        :columns="tableColumn"
        :data="detailData.stock_list"
        :keyboard-config="{ isArrow: true }"
        :footer-method="footerMethod"
      >
        <!-- slot_default -->
        <template #default_report_remark="{ row }">
          <el-input
            v-model="row.report_remark"
            size="mini"
            placeholder="请输入备注"
            :disabled="isSelfDisabled"
          />
        </template>
      </vxe-grid>
    </div>

    <div class="cont-title m-t-10">温馨提示</div>
    <e-form
      ref="refForm2"
      class="m-t-10"
      :config="formConfig"
      :column="formColumn3"
      :data.sync="detailData.report_bill"
      :disabled="isSelfDisabled"
    />
    <div class="flex flex-x-end m-t-10">
      <el-button v-if="!isSelfDisabled" type="primary" size="mini" @click="detailSave(true)"
        >保存报价单</el-button
      >
      <el-button v-if="id && isChuangJian" type="default" size="mini" @click="detailPrint"
        >打印报价单</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    isChuangJian: {
      type: Boolean,
      refault: false
    },
    isFuZe: {
      type: Boolean,
      refault: false
    }
  },
  data() {
    return {
      isDetailPrint: false,
      detailData: {
        report_bill: {},
        stock_list: []
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn1: [
        {
          type: 'text',
          title: '报价单号',
          field: 'bill_code',
          disabled: true
        },
        {
          type: 'text',
          title: '供应商',
          field: 'saler_company_name',
          disabled: true
        },
        {
          type: 'text',
          title: '联系人',
          field: 'saler',
          disabled: true
        },
        {
          type: 'number',
          title: '手机号',
          field: 'saler_phone',
          disabled: true
        },
        {
          type: 'text',
          title: '地址',
          field: 'saler_address',
          disabled: true
        }
      ],
      formColumn2: [
        {
          type: 'date',
          title: '报价日期',
          field: 'report_time',
          disabled: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '采购方',
          field: 'buyer_company_name',
          disabled: true
        },
        {
          type: 'text',
          title: '联系人',
          field: 'buyer',
          disabled: true
        },
        {
          type: 'number',
          title: '手机号',
          field: 'buyer_phone',
          disabled: true
        },
        {
          type: 'text',
          title: '地址',
          field: 'buyer_address',
          disabled: true
        }
      ],
      formColumn3: [
        {
          type: 'radio',
          title: '是否含运',
          field: 'has_freight',
          disabled: true,
          options: [
            {
              key: '否',
              val: false
            },
            {
              key: '是',
              val: true
            }
          ]
        },
        {
          type: 'radio',
          title: '是否含税',
          field: 'has_tax',
          disabled: true,
          options: [
            {
              key: '否',
              val: false
            },
            {
              key: '是',
              val: true
            }
          ]
        },
        {
          type: 'text',
          title: '说明',
          field: 'remark',
          disabled: !this.isChuangJian,
          width: '100%'
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '商品名称',
          field: 'name'
        },
        {
          title: '规格(mm)',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'sales_price'
        },
        {
          title: '金额',
          field: 'sales_amount'
        },
        {
          title: '备注',
          width: 300,
          slots: { default: 'default_report_remark' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ]
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 610}px`
      return result
    },
    isSelfDisabled() {
      let { status_str } = this.detailData.report_bill
      let isVerify = this.id && (status_str === '暂存' || status_str === '已驳回')
      let isChuangJianDo = isVerify && this.isChuangJian
      let isFuZeDo = this.isFuZe
      let result = !(isChuangJianDo || isFuZeDo)
      return result
    }
  },
  mounted() {
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/reportBill2/detail',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.detailData = this.$util.deepCopy(res.data)

          // 是否含税文案处理
          this.formColumn3.forEach((item) => {
            if (item.field === 'has_tax') {
              if (this.detailData.report_bill.bill_tax_rate) {
                item.options[1].key = `是(含13%增值税发票)`
              }
            }
          })
        }
      })
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'sales_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 详情-保存
    detailSave(isPrompt) {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/reportBill2/saveOrUpdate',
        data: this.detailData
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (isPrompt) this.$message.success('操作成功')
          if (this.isDetailPrint) {
            this.isDetailPrint = false
            this.detailPrintConfirm()
            return
          }
        }
      })
    },
    // 详情-打印
    detailPrint() {
      if (this.isSelfDisabled) {
        this.detailPrintConfirm(this.id)
      } else {
        this.isDetailPrint = true
        this.detailSave()
      }
    },
    // 详情-打印-确认
    detailPrintConfirm() {
      window.open(`/new/verify/print/quote?id=${this.id}`, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.cont-main {
  .cont-title {
    line-height: 24px;
    font-weight: bold;
    font-size: 12px;
    border-bottom: 1px solid @colorGrayD;
    margin-bottom: 5px;
  }
  .cont-form {
    display: flex;
    width: 100%;
    margin-top: 10px;
  }
  .cont-form {
    display: flex;
    width: 100%;
    margin-top: 5px;
  }
  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  /deep/ .el-form-item__label {
    line-height: 24px;
  }
  /deep/ .el-form-item__content {
    height: 24px;
    line-height: 24px;
  }
  /deep/ .el-input__inner {
    height: 24px;
    line-height: 24px;
  }
  /deep/ .el-input__icon {
    line-height: 24px;
  }
}
</style>
